import { Outlet } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Box, Container } from '@mui/material';
import { useAuth } from 'react-oidc-context';
import Navigation from './Navigation';
import { useUser } from '../../hooks/useUser';
import { LogoutButton } from '../Auth/LogoutButton';
import { WhatsNewDialog } from '../Common/WhatsNewDialog';

const Layout = () => {
  const auth = useAuth();
  const { userInfo } = useUser();

  const handleLogout = () => {
    auth.signoutRedirect({
      post_logout_redirect_uri: window.location.origin + '/login'
    });
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar sx={{
          display: 'flex',
          justifyContent: 'space-between',
          minHeight: { xs: '48px', sm: '48px' }, // ヘッダーの高さをさらに小さく
          p: { xs: 0.5, sm: 1 } // パディングをさらに小さく
        }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              fontSize: { xs: '1rem', sm: '1.25rem' },
              whiteSpace: 'nowrap'
            }}
          >
            工事管理システム
          </Typography>
          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: { xs: 1, sm: 2 },
            ml: 2
          }}>
            {userInfo && (
              <Typography
                variant="body1"
                component="div"
                sx={{
                  fontSize: { xs: '0.875rem', sm: '1rem' },
                  whiteSpace: 'nowrap'
                }}
              >
                ログインユーザー：{userInfo.lastName}
              </Typography>
            )}
            <LogoutButton />
          </Box>
        </Toolbar>
      </AppBar>
      <Navigation />
      
      {/*
      コンテンツエリアの幅:
      - モバイル(xs): 画面幅100%（左右余白を最小化）
      - タブレット(sm): 95%
      - デスクトップ(md+): 90%
      */}
      <Container
        maxWidth={false}
        disableGutters
        sx={{
          flex: 1,
          width: { xs: '100%', sm: '95%', md: '96%' },
          mx: 'auto',
          py: 0.5
        }}
      >
        <Outlet />
      </Container>

      {/* ログイン後の初回表示用「UI 更新のお知らせ」モーダル */}
      <WhatsNewDialog />
    </Box>
  );
};

export default Layout;